const newsSwiper = new Swiper('#news-swiper', {
  slidesPerView: 3,
  spaceBetween: 30,

  navigation: {
    nextEl: '#news-swiper-right',
    prevEl: '#news-swiper-left',
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
    },

    675: {
      slidesPerView: 2,
      spaceBetween: 10,
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

const productsSwiper = new Swiper('#products-swiper', {
  slidesPerView: 3,
  spaceBetween: 0,
  centeredSlides: true,
  initialSlide: 1,

  navigation: {
    nextEl: '#products-swiper-right',
    prevEl: '#products-swiper-left',
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
    },

    675: {
      slidesPerView: 2,
    },

    830: {
      slidesPerView: 3,
    },
  },
});

const video = new Plyr('#player');
